module.exports = __webpack_public_path__ + "static/media/travel.a9266307.jpg";